import styled, { createGlobalStyle } from "styled-components";

const REMOVE_PADDING_MARGIN = "margin: 0; padding: 0;";
const FULL_VIEW = "width: 100vw; height: 100vh;"

const TERMINAL_COLOR = "#020b29";
const TERMINAL_HEADER_COLOR = "#000d38";


const TERMINAL_HEADER_HEIGHT = "28px";
const FILE_HEIGHT = "2.2rem"; // kvuli bordrum

const IDE_GRAY_COLOR = "#001e82";

export const GlobalCSS = createGlobalStyle`
    body, html {
        ${REMOVE_PADDING_MARGIN}
        color: white;
        font-family: monaco, Consolas, "Lucida Console", monospace; 
        height: 100%;
        width: 100%;
        overflow-x: auto;
        background: #00000f;
    }
    ::-webkit-scrollbar {
        width: 0.5rem;
    }

    ::-webkit-scrollbar-track {
        background: #001e82; 
    }
 

    ::-webkit-scrollbar-thumb {
        background: ${TERMINAL_COLOR};
    }

    .selected {
        background: #666666;
    }

    @media screen and (max-width: 530px) {
        ul.text {
            li {
                font-size: 0.8rem;
            }
        }
    }

    main {
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        ${REMOVE_PADDING_MARGIN}
        z-index: 2;
    }
`;

export const Intro = styled.div`
    display: grid;
    place-items: center;
    ${FULL_VIEW}
`;

export const Terminals = styled.div`
    display: flex;
    overflow-y: auto;
    @media screen and (max-width: 1000px) {
        display: inline;
    }
`;

export const Window = styled.div`
    background: ${TERMINAL_COLOR};
    width: 40vw;
    height: 50vh;
    margin: 0 5vw 0 5vw;
    border-radius: 10px;

    @media screen and (max-width: 1000px) {
        width: 90vw;
        height: 40vh;
        margin: 5vh 5vw;
    }
`;

export const Header = styled.header`
    height: ${TERMINAL_HEADER_HEIGHT};
    border-radius: 10px 10px 0 0;
    background-color: ${TERMINAL_HEADER_COLOR};
    border-bottom: 1px solid ${IDE_GRAY_COLOR};
    
`;

export const Explorer = styled.div`
    background: #000d38;
    width: 120px;

    @media screen and (min-width: 530px) {
        border-right: 1px solid ${IDE_GRAY_COLOR};
        border-radius: 0 0 0 10px;
    }

    @media screen and (max-width: 530px) {
        border-bottom: 1px solid ${IDE_GRAY_COLOR};
    } 

    ul {
        ${REMOVE_PADDING_MARGIN}
        list-style-type: none;
        height: ${TERMINAL_HEADER_HEIGHT};
        margin: 0;
        display: flex;
        flex-direction: column;
    }

    li {
            cursor: pointer;
            display: inline-block;
            width: auto;
            height: ${FILE_HEIGHT};
            padding: 5px;
            font-weight: bold;
            font-size: 1rem !important;
        }

    li:hover {
        transition: background-color 1000ms linear;
        background: #999999;
    }
    
    @media screen and (max-width: 530px) {
        ul {
            display: block;
        }
        li {
                float: left;
                height: ${TERMINAL_HEADER_HEIGHT};
                font-size: 0.8rem !important;
                padding: 0 5px;
        }
        width: 100%;
        margin: 0;
    } 
`;

export const Left = styled.div`
    text-align: left;
    margin: auto 0;
`;

export const ThatShitInTopLeftCorner = styled.ul`
    list-style-type: none;
    display: inline;
    ${REMOVE_PADDING_MARGIN}
    li {
        display: inline;
        margin: auto 5px;
    }
`;

export const IDE = styled.div`
    display:flex;
    flex-direction: row;
    height: calc(100% - ${TERMINAL_HEADER_HEIGHT});
    width: 100%;
    overflow-y: auto;
    @media screen and (max-width: 530px) {
        display: block;
    } 
`;

export const Code = styled.ul`
    color: #b5b5b5;
    counter-reset: number;
    list-style-type: none;
    padding: 10px;
    margin: 0;
    overflow-y: auto;

    li::before {
        counter-increment: number;
        content: counter(number)"\xa0\xa0";
    }
`;

export const C = {
    P: styled.span`
        color: #c678dd;
    `,
    Y: styled.span`
        color: #d9c062;
    `,
    R: styled.span`
        color: #e06c75;
    `,
    B: styled.span`
        color: #3792ef;
    `,
    O: styled.span`
        color: #d19a66;
    `,
    G: styled.span`
        color: #7ac379;
    `
}

export const TerminalText = styled.ul`
    list-style-type: none;
    margin: 10px;
    padding: 0;
`;

export const Padding = styled.div`
    padding-top:2px;
`;

export const OverFlowAuto = styled.div`
    overflow-y: auto;
    height: calc(100% - ${TERMINAL_HEADER_HEIGHT});
`;

export const AboutMe = styled.div`
    margin: 0 8vw 0 8vw;
    background: #020b29;
    border: 1px solid #020b29;
    border-radius: 10px;
    padding: 6vh 3vw 0 3vw;
`;

const BaseTitle = styled.div` 
    color: rgba(0, 0, 0, 0);
    -webkit-text-stroke-width: 1px;
    -webkit-text-stroke-color: white;

`;

const BaseDesc = styled.div`   
    color: #cccccc;
    margin: 2vh 0;

    a {
        text-decoration: none;
        color: #2ecc71;
    }
`;

export const AboutMeTitle = styled(BaseTitle)`
    font-size: 5rem;
    @media (max-width: 550px) {
        font-size: 2rem;
    }
`;

export const SubTitle = styled(BaseTitle)`
    font-size: 2.5rem;
    @media (max-width: 550px) {
        font-size: 1.4rem;
    }
`;
export const SubSubTitle = styled(BaseTitle)`
    font-size: 2rem;
    @media (max-width: 550px) {
        font-size: 1.2rem;
    }
`;

export const AboutMeDescription = styled(BaseDesc)`
    font-size: 1.2rem;
    @media (max-width: 550px) {
        font-size: 0.9rem;
    }
`;

export const Line = styled.div`
    border: gray solid 1px;
    height: 0;
    width: auto;
    margin: 2vh 0;
`;

export const FullView = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
`;

export const Footer = styled.footer`
    background: #020b29;
    margin: 10vh 0 0 0;
    padding: 1vh 2vw;
`;

export const IconsRow = styled.div`
    display: flex;
    color: #99aab5; 
    font-size: 25px; 
    justify-content: center;
    svg {
        margin: 3vh 3vw;
        cursor: pointer;
      }
    svg:hover {
        color:white;
        transition: color 1s;
    }
`;